import React from 'react'
import './auth.styles.scss'
import '../form.styles.scss'
import iconLogo from '../../assets/images/logo.png'

const AuthTemplate = (props) => {
    return (
        <section className="auth">
            <div>
                <div className="container">
                    <header>
                        <img alt="" src={iconLogo} />
                    </header>
                    {props.children}
                    <footer>
                        <p>© 2021 Skysenx Limited. All rights reserved.</p>
                    </footer>
                </div>
            </div>
            <div>
                <div className="shade"></div>
            </div>
        </section>
    )
}

export default AuthTemplate